import { useAppDispatch } from "../../../../app/hooks";
import { fetchEmploymentExpenses } from "../../../employment/employmentSlice";
import {
  ExpensesForEmploymentFilters,
  Kind,
} from "../../../employment/employmentApi";
import { FieldValues, FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { isFulfilled } from "@reduxjs/toolkit";
import ExpensesForEmploymentFormFields from "./ExpensesForEmploymentFormFields";
import ExpensesForEmploymentTables from "./ExpensesForEmploymentTables";
import { ExpenseForEmployment } from "./types";
import { isoFormat } from "../../../../common/helpers/formatDateTime";

type Props = {
  employmentId: string;
  startDate: string;
  endDate: string;
};

const ExpensesForEmployment = ({ employmentId, startDate, endDate }: Props) => {
  const [payloadData, setPayloadData] = useState<ExpenseForEmployment[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const filters = ["employmentId", "talentId", "unit"];

  const allHeaders = payloadData.flatMap((row) => Object.keys(row));
  const headers = [...new Set(allHeaders)].filter(
    (header) => !filters.includes(header),
  );

  const dispatch = useAppDispatch();

  const defaultValues = {
    dateFrom: startDate ? new Date(startDate) : null,
    dateTo: endDate ? new Date(endDate) : null,
  };

  const methods = useForm({
    defaultValues,
    mode: "onChange",
  });

  useEffect(() => {
    methods.setValue("dateFrom", startDate ? new Date(startDate) : null);
    methods.setValue("dateTo", endDate ? new Date(endDate) : null);
  }, [startDate, endDate, methods]);

  const onSubmit = (fieldValues: FieldValues, kind: Kind) => {
    const formatedFrom = format(fieldValues.dateFrom, isoFormat);
    const formatedTo = format(fieldValues.dateTo, isoFormat);

    const filters: ExpensesForEmploymentFilters = {
      employmentId,
      from: formatedFrom,
      to: formatedTo,
      kind,
    };
    setIsLoading(true);

    dispatch(fetchEmploymentExpenses(filters)).then((action) => {
      if (isFulfilled(action)) {
        setPayloadData(action.payload);
      }
      setIsLoading(false);
    });
  };

  return (
    <>
      <FormProvider {...methods}>
        <ExpensesForEmploymentFormFields
          isLoading={isLoading}
          onSubmit={onSubmit}
        />
      </FormProvider>
      <ExpensesForEmploymentTables
        payloadData={payloadData}
        headers={headers}
        isLoading={isLoading}
      />
    </>
  );
};

export default ExpensesForEmployment;
